import { render, staticRenderFns } from "./addressLocationAdd.vue?vue&type=template&id=2ea1ee61&scoped=true&"
import script from "./addressLocationAdd.vue?vue&type=script&lang=ts&"
export * from "./addressLocationAdd.vue?vue&type=script&lang=ts&"
import style0 from "./addressLocationAdd.vue?vue&type=style&index=0&id=2ea1ee61&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea1ee61",
  null
  
)

export default component.exports